import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import Components         from './components'
import MyDetailsPage      from './my-details'
import MyPreferencesPage  from './my-preferences'

import component from './my-profile.component'

let module = angular.module('myProfileModule', [
  uiRouter,
  Components,
  MyDetailsPage,
  MyPreferencesPage
])

.config(($stateProvider) => {
  'ngInject'

  $stateProvider
    .state('profile.myProfile', {
      url: '/my-profile',
      component: 'myProfilePage',
      redirectTo: 'profile.myProfile.myDetails',
      authenticate: true
    })
})

.component('myProfilePage', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/profile/my-profile/index.js